import { get } from 'core/helpers/fetch';
import {
  FETCH_TABOO_INSTANCE_STARTED,
  FETCH_TABOO_INSTANCE_SUCCEED,
  FETCH_TABOO_INSTANCE_FAILED,
} from 'app/games/taboo/reducers/instances';

function fetchInstance(id) {
  return async dispatch => {
    dispatch({ type: FETCH_TABOO_INSTANCE_STARTED, payload: { id } });
    try {
      const instance = await dispatch(get(`/games/taboo/instances/${id}`));
      dispatch({ type: FETCH_TABOO_INSTANCE_SUCCEED, payload: { instance } });
      return instance;
    } catch (exception) {
      dispatch({ type: FETCH_TABOO_INSTANCE_FAILED, payload: { exception } });
      throw exception;
    }
  };
}

export default fetchInstance;
